import React from 'react';
import { useTranslation } from 'react-i18next';

const ColumnFilter = ({ column }) => {
  const { t } = useTranslation('common');
  const { filterValue, setFilter } = column;

  return (
    <span>
      {t('search')}: <input value={filterValue || ''} onChange={(e) => setFilter(e.target.value)} />
    </span>
  );
};

export default ColumnFilter;
